export const qualityRules = [
  {
    from: 0,
    to: 25,
    label: 'Péssimo',
    background: '#cd5252',
    color: '#fff',
  },
  {
    from: 25,
    to: 50,
    label: 'Ruim',
    background: '#cd8a52',
    color: '#fff',
  },
  {
    from: 50,
    to: 75,
    label: 'Bom',
    background: '#52a3cd',
    color: '#fff',
  },
  {
    from: 75,
    to: 100,
    label: 'Ótimo',
    background: '#52cd7a',
    color: '#fff',
  },
];
